import {ComposableMap, Geographies, Geography, Marker, Line } from "react-simple-maps";

const MapChart = (props) => {
 

    const geoUrl = "/map.json";
    let data = props.data ? props.data : null;
    
    if(!data)
        return <></>

    let {flightInfo, awbInfo, flights, stations} = data

    if(!flightInfo || !awbInfo)
        return <></>


    stations = stations ? stations : []
    flights  = flights ? flights : []
  
    let {origin, destination, positions, last_position, waypoints, actual_in, actual_on} = flightInfo
    let origin_iata = origin ? origin.code_iata : null
    let dest_iata = destination ? destination.code_iata : null
    waypoints = waypoints ? waypoints : []

    if(!origin_iata || !dest_iata || !last_position )
        return <></>

    let origin_ = stations.filter((s) => s.station_code === origin_iata)[0]
    let destination_ =  stations.filter((s) => s.station_code === dest_iata)[0]
  
    if(!origin_ || !destination_)
        return <></>


    //POSITIONING MARKERS
    var markers = [];

    //ORIGIN and DEST MARKERS
    markers.push({
        name: origin_.station_code, 
        coordinates: [origin_.long , origin_.lat ] ,  
        time: "", 
        status : "done"
    } )
    
    markers.push({
        name: destination_.station_code, 
        coordinates: [destination_.long, destination_.lat],  
        time: "", 
        status : "todo" 
    })

    let center = { 
        long :  (origin_.long + destination_.long)/2, 
        lat : (origin_.lat + destination_.lat)/2 
    }

    //OTHER MILESTONES
    let x;

    flights.forEach((f)=>{
        
        //origin points
        if(f.origin !== origin_.station_code && f.origin !== destination_.station_code){
            x = stations.filter((s)=>s.station_code === f.origin)[0];
            
            if(x)
                markers.push({ 
                    name: f.origin, 
                    coordinates: [x.long, x.lat],   
                    status : "other" 
                } )
        }

        //dest points
        if(f.dest !== origin_.station_code && f.dest !== destination_.station_code   ){
        
        x = stations.filter((s)=>s.station_code === f.dest)[0];
        
        if(f.dest === dest_iata && x)
            markers.push({ name: f.dest, coordinates: [x.long, x.lat],  status : "destination" } )
        else if(x)
            markers.push({ name: f.dest, coordinates: [x.long, x.lat],  status : "other" } )
        }
  
    })

    //ORIGIN-PLANE TRAJECTORY
    // THEORETICAL
    let lines = [];

    for(let i = 0; i < waypoints.length; i = i+2){
        
        let lat = parseFloat(waypoints[i])
        let long = parseFloat(waypoints[i+1]) 

        lines.push([long , lat] )
        
    }  

    let lines2 = [];

    for(let i = 10; i < positions.length ; i++){

        let p = positions[i]

        if(p && i < positions.length)
            lines2.push([p.longitude, p.latitude])
    }

    // PLANE ICON ANGLE CALCULATION
    // ANGLE IS CALCULATED BETWEEN TWO CLOSEST POINTS FROM PLANE

    var thetaPlane = 0;
    var translatePlane = 0;
    var translateDestLabel_X = 0
    var translateDestLabel_Y = 0
    var translateOrigLabel_X = 0
    var translateOrigLabel_Y = 0

    //PLANE ANGLE & TEXT ORIENTATION
    // THIS IS BASED ON DIRECTION FROM LAST POINTS OF PLANE TRAJECTORY

    if(positions.length > 5){
    
        //LETS COLLECT COORDINATES OF LAST POINTS FROM TRAJECTORY
        let length = positions.length;

        let lat2 = positions[length-1].latitude
        let long2 = positions[length-1].longitude

        let lat1 = positions[length-5].latitude
        let long1 = positions[length-5].longitude

        //plane is repositioned at the end of trajectory. Sometimes there is a difference, this cancels it.
        //var longP = long2
        //var latP = lat2

        let deltaLong = Math.abs( Math.abs(long2)  - Math.abs(long1))
        let deltaLat = Math.abs( Math.abs(lat2)  - Math.abs(lat1))

        let alpha = (180/Math.PI) * Math.atan( deltaLat / deltaLong  ) // absolute angle between trajectory direction and horizontal axis

        //console.log("alpha", alpha, "deltaLong", deltaLong, "deltaLat", deltaLat)
        
        if( lat2 > lat1 && long2 > long1  ){
            //console.log("DIR. NORD EST ") 

            //translate text
            translateOrigLabel_X = 15
            translateOrigLabel_Y = -15

            translateDestLabel_X = -15
            translateDestLabel_Y = 15

            thetaPlane =  45 - alpha  // 45° orienting plane towards east
            
            if(alpha < 3)
                translatePlane = "0,-10"
            else
                translatePlane =  "-12,-7" 

        }

        if( lat2 < lat1 && long2 > long1 ){
            //console.log("DIR. SUD EST / ")

            //translate text
            translateDestLabel_X = -15
            translateDestLabel_Y = -15

            translateOrigLabel_X = 15
            translateOrigLabel_Y = 15

            thetaPlane =  45 + alpha  // 45° orienting plane towards east
            
            if(alpha < 3)
                translatePlane = "15,-2"
            else
                translatePlane = "15,0"

        }

        if(lat2 > lat1 && long2 < long1   ){

            translateDestLabel_X = -15
            translateDestLabel_Y = -15

            translateOrigLabel_X =  15
            translateOrigLabel_Y =  15

            thetaPlane =  -135 + alpha // 135° orienting plane towards east

            if(alpha < 5)
            translatePlane = "-5,15"
            else
            translatePlane =   "-9,11" 

        }

        if(lat2 < lat1 && long2 < long1  ){

            thetaPlane = -135 - alpha // 135 orienting plane towards east

            //translate text
            translateOrigLabel_X = -15
            translateOrigLabel_Y = 15

            translateDestLabel_X = 20
            translateDestLabel_Y = -20

            //adjusting plane position after rotation
            if(alpha < 3)
            translatePlane = "0,15"
            else
            translatePlane = "10,10"

        }
    
    }
 
    return (
        <ComposableMap
            projection="geoMercator"
            projectionConfig = {{
                center : [center.long, center.lat],
                scale: 300,
                width : 50
            }}
        >
        <Geographies 
            geography={geoUrl}>
            {({ geographies }) => geographies.map(geo => (
                <Geography
                    key={geo.rsmKey}
                    geography={geo}
                    style= {{
                        default: {
                            fill: "#043d58",
                            stroke: "#668392",
                            strokeWidth: 0.75
                        },
                        hover: {
                            fill: "#89CFF0",
                            stroke: "black",
                            strokeWidth: 1,
                            
                        },  
                        active: {
                            fill: "#043d58",
                            stroke: "#668392",
                            strokeWidth: 0.75,
                        }             
                    }}
                />
                ))
            }
        </Geographies>  
    
        {markers.map(({ name, coordinates,status }) => {
            
            let color = "white";
            let size ="1";
            let strokeWidth = "0"
            let fontSize = "0.4em"

            let translate_X = 0
            let translate_Y = 0

            if(status === "done"){
            color = "#32a852";
            size ="5"
            strokeWidth = "2"
            fontSize = "1.2em"
            translate_X = translateOrigLabel_X
            translate_Y = translateOrigLabel_Y
            }

            if(status === "todo"){
            color = "orange";
            size = "5"
            strokeWidth = "2"
            fontSize = "1.2em"
            translate_X = translateDestLabel_X
            translate_Y = translateDestLabel_Y
            }
        
            if(status === "other"){
            color = "grey";
            size = "5"
            strokeWidth = "1"
            fontSize = "0.7em"
            }
            
            
        return(
            <Marker key={name} coordinates={coordinates} >
            <g
                fill= {color}
                stroke="#FF5533"
                strokeWidth="1"
                strokeLinecap="round"
                strokeLinejoin="round"
                transform="translate(0, 0)"
            >
                <circle cx="0" cy="0" r= {size} stroke="#000000" strokeWidth={strokeWidth}/>
    
            </g>
            
            <text
                textAnchor="middle"
                y={translate_X}
                x={translate_Y}
                fontSize = {fontSize}
                style={{ fontFamily: "system-ui",   color : "white" }}
            >
                {name} 
            </text>
            
            </Marker>
        ) }
        )}

        <Line
            coordinates={lines}
            stroke="#776865"
            strokeWidth={1}
            strokeDasharray={[5, 5]}      
        />

        <Line
            coordinates={lines2}
            stroke="red"
            strokeWidth={1} 
        />

        <Marker key="plane" 
            coordinates={[last_position.longitude, last_position.latitude]} 
        >

            {positions.length > 5 ?
            <g 
                color = "white"  
                stroke = "red" 
                strokeWidth = {2} 
                transform = {"translate("+translatePlane+"),scale(0.04,0.04),rotate("+thetaPlane.toString()+")"}
            >
                                    
                {(!last_position.longitude && !last_position.latitude) || actual_in || actual_on ? <span></span> :  
                <svg> 
                <path d="M497.535,14.465c-19.569-19.568-51.395-19.241-70.557,0.726L322.092,124.488L66.131,39.781L12.4,93.513l213.352,131.365
                L117.796,337.372l-69.231-11.366L0,374.571l101.78,35.649L137.429,512l48.565-48.565l-11.366-69.231l112.494-107.955
                L418.487,499.6l53.732-53.732l-84.706-255.961L496.808,85.022C516.776,65.86,517.103,34.034,497.535,14.465z"/> 
                </svg>
                }
                        
            </g> : null 

            }

        </Marker>

        </ComposableMap>
    );
};
export default MapChart;